import { combineReducers } from 'redux'
import {
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILURE,
  GET_CATEGORIES_LOADING,
} from '../actions'
import { keyBy, uniq, map } from 'lodash'

const loading = (prevState = false, action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS:
    case GET_CATEGORIES_FAILURE:
      return false
    case GET_CATEGORIES_LOADING:
      return true
    default:
      return prevState
  }
}

const categoriesBySlug = (prevState = {}, action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS:
      return keyBy(
        action.payload.map(d => ({
          ...d,
          mondo: d.mondo.slug,
        })),
        'slug'
      )
    default:
      return prevState
  }
}

const worldsBySlug = (prevState = {}, action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS:
      return keyBy(action.payload.map(d => d.mondo), 'slug')
    default:
      return prevState
  }
}

const categoriesByWorld = (prevState = {}, action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS:
      return action.payload.reduce((r, d) => {
        return {
          ...r,
          [d.mondo.slug]: [...(r[d.mondo.slug] || []), d.slug],
        }
      }, {})
    default:
      return prevState
  }
}

const worldsSlugs = (prevState = [], action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS:
      return uniq(map(action.payload.map(d => d.mondo), 'slug'))
    default:
      return prevState
  }
}

const categoriesSlugs = (prevState = [], action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS:
      return map(action.payload, 'slug')
    default:
      return prevState
  }
}

export default combineReducers({
  loading,
  categoriesBySlug,
  categoriesSlugs,
  worldsBySlug,
  worldsSlugs,
  categoriesByWorld,
})



// WEBPACK FOOTER //
// ./src/reducers/categoriesAndWorlds.js